import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { addSubscriptionFeature } from '../../store/actions/subscription/subscription.action';

const SinglePieceRow = ({
  piece,
  page,
  ind,
  subscriptions,
  mode,
  pieceSubscriptionMethods,
  methods
}) => {
  const [statePiece, setStatePiece] = useState(null);
  const { deletePiece, updatePiece, getPieceByID } = methods;

  useEffect(() => {
    setStatePiece(JSON.parse(JSON.stringify(piece)));
  }, [piece]);

  const handleGetPieceByID = async () => {
    try {
      const updatedPiece = await getPieceByID(statePiece.id);
      setStatePiece(updatedPiece);
    } catch (error) {
      console.error('Error fetching piece:', error);
    }
  };

  const setSubscription = (subscription_id, name) => {
    const { addPieceSubscription } = pieceSubscriptionMethods;
    addPieceSubscription(
      { subscription_id, piece_id: statePiece.id, name },
      piece.subscriptions
    );
  };

  const deleteSubscription = async (subscription_id, name) => {
    try {
      const { getPieceSubscriptionByID, deletePieceSubscription } = pieceSubscriptionMethods;
      const piece_subscriptions = await getPieceSubscriptionByID(statePiece.id);
      const foundSubscription = _.find(piece_subscriptions, {
        piece_id: statePiece.id,
        subscription_id
      });

      if (foundSubscription) {
        deletePieceSubscription(
          { id: foundSubscription.id, subscription_id, name },
          piece.subscriptions
        );
      }
    } catch (error) {
      console.error('Error deleting subscription:', error);
    }
  };

  const handleSubscriptionChange = (e, subscription) => {
    if (e.target.checked) {
      setSubscription(subscription.id, subscription.name);
    } else {
      deleteSubscription(subscription.id, subscription.name);
    }
  };

  const handleDelete = () => {
    if (window.confirm(`Are you sure you want to delete "${piece.title}"?`)) {
      deletePiece(piece);
    }
  };

  const truncateDescription = (desc, maxLength = 100) => {
    if (!desc) return '';
    const cleanDesc = desc.replace(/<[^>]*>/g, '');
    return cleanDesc.length > maxLength
      ? cleanDesc.substr(0, maxLength) + '...'
      : cleanDesc;
  };

  if (!statePiece) {
    return (
      <tr>
        <td colSpan="11" style={{ textAlign: 'center', padding: '20px' }}>
          Loading...
        </td>
      </tr>
    );
  }

  const description = truncateDescription(piece.description);

  return (
    <tr key={statePiece.id}>
      <td>{(page.current - 1) * page.size + (ind + 1)}</td>
      <td>{statePiece.title}</td>
      <td>{description}</td>
      <td>{statePiece.pieceproductid_google || 'N/A'}</td>
      <td>{statePiece.composer?.name || 'N/A'}</td>
      <td>{statePiece.artist?.title || 'N/A'}</td>
      <td>
        {subscriptions.map((s) => (
          <div className="subs-check" key={`${piece.id}-${s.id}`}>
            <input
              type="checkbox"
              defaultChecked={_.find(piece.subscriptions, { id: s.id }) ? true : false}
              onChange={(e) => handleSubscriptionChange(e, s)}
              aria-label={`Toggle ${s.name} subscription for ${piece.title}`}
            />
            <div>{s.name}</div>
          </div>
        ))}
      </td>
      <td>{statePiece.price || 'N/A'}</td>
      <td>
        <input
          onChange={(e) => updatePiece(e, { latest: e.target.checked, id: piece.id }, piece)}
          defaultChecked={piece.latest}
          type="checkbox"
          aria-label={`Mark ${piece.title} as latest`}
        />
      </td>
      <td>
        <input
          onChange={(e) => updatePiece(e, { featured: e.target.checked, id: piece.id }, piece)}
          defaultChecked={piece.featured}
          type="checkbox"
          aria-label={`Mark ${piece.title} as featured`}
        />
      </td>
      <td style={{ textAlign: 'center' }}>
        {mode === 'edit' ? (
          <div className="action-buttons">
            <Link
              className="cus-btn-primary"
              to={`/piece/edit/${piece.id}`}
              aria-label={`Edit ${piece.title}`}
            >
              Edit
            </Link>
            <button
              className="cus-btn-danger mr-15"
              onClick={handleDelete}
              aria-label={`Delete ${piece.title}`}
            >
              Delete
            </button>
          </div>
        ) : (
          <Link
            className="cus-btn-primary"
            to={`/piece/view/${piece.id}`}
            aria-label={`View ${piece.title}`}
          >
            View
          </Link>
        )}
      </td>
    </tr>
  );
};

export default SinglePieceRow;
